/* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */

import {EDeviceType} from './IDevice';
import {isbot} from 'isbot';

/**
 * Represents a Device Manager
 */
class DeviceMgr {
	// The device type can not be changed on the fly so we can cache it
	private deviceType: EDeviceType = null;
	protected botsUserAgents: string[] = [
		'AhrefsBot',
		'heritrix',
		'FatBot',
		'Wget',
		'Yahoo! Slurp',
		'YandexBot',
		'Baiduspider',
		'Googlebot'
	];

	/**
	 * Match mobile device by user agent
	 * @param {string} userAgent user agent
	 * @returns {boolean} true if device is mobile
	 */
	private matchMobileAgent(userAgent: string): boolean {
		// eslint-disable-next-line max-len
		const MOBILE_REGEX = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/;

		return MOBILE_REGEX.test(userAgent);
	}

	/**
	 * Match tablet device by user agent
	 * @todo: implement this method in case we need to detect tablet devices
	 * @param {string} userAgent user agent
	 * @returns {boolean} true if device is mobile
	 */
	private matchTabletAgent(userAgent: string): boolean {
		return false;
	}

	/**
	 * Get device type by user agent
	 * @param userAgent user agent
	 * @returns {EDeviceType} device type
	 */
	getDeviceType(userAgent: string): EDeviceType {
		if (this.deviceType) {
			return this.deviceType;
		}

		let deviceType: EDeviceType = EDeviceType.DESKTOP;

		if (isbot(userAgent)) {
			deviceType = EDeviceType.BOT;
		} else if (this.matchMobileAgent(userAgent)) {
			deviceType = EDeviceType.MOBILE;
		} else if (this.matchTabletAgent(userAgent)) {
			deviceType = EDeviceType.TABLET;
		}

		this.deviceType = deviceType;

		return this.deviceType;
	}

	/**
	 * Check if the device is a bot
	 * @param userAgent user agent
	 * @returns {boolean} true if the device is a bot
	 */
	isBot(userAgent: string): boolean {
		return this.getDeviceType(userAgent) === EDeviceType.BOT;
	}

	/**
	 * Check if the device is a mobile
	 * @param userAgent user agent
	 * @returns {boolean} true if the device is a bot
	 */
	isMobile(userAgent: string): boolean {
		return this.getDeviceType(userAgent) === EDeviceType.MOBILE;
	}

	/**
	 * Checks if the userAgent string corresponds to Safari browser on iOS or macOS.
	 * @param {string} userAgent - The userAgent string to check.
	 * @returns {boolean} - true if the userAgent corresponds to Safari on iOS or macOS, false otherwise.
	 */
	isSafari(userAgent: string): boolean {
		// eslint-disable-next-line max-len
		const SAFARI_REGEX = /^(?=.*\b(?:Macintosh|iP(?:hone|ad|od)).*Safari\b)(?!.*(?:CriOS|FxiOS|OPiOS|EdgiOS|Chrome|Opera)).*$/;

		return SAFARI_REGEX.test(userAgent);
	}
}

export default new DeviceMgr();
